// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-tabs {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.tabs-header-wrapper {
  position: relative;
  background-color: #0f172a;
  border-bottom: 1px solid #334155;
}

.tabs-header-wrapper::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 40px;
  background: linear-gradient(to right, transparent, #0f172a);
  pointer-events: none;
}

.tabs-header {
  display: flex;
  gap: 4px;
  padding: 12px 16px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.tabs-header::-webkit-scrollbar {
  display: none;
}

.tab-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: transparent;
  border: 1px solid #334155;
  border-radius: 6px 6px 0 0;
  color: #94a3b8;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

.tab-button:hover {
  color: #cbd5e1;
  border-color: #475569;
}

.tab-button.active {
  background-color: #1e293b;
  border-color: #475569;
  color: #f1f5f9;
}

.tabs-content {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.no-selection {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #64748b;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ContentTabs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX,2DAA2D;EAC3D,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB","sourcesContent":[".content-tabs {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n}\r\n\r\n.tabs-header-wrapper {\r\n  position: relative;\r\n  background-color: #0f172a;\r\n  border-bottom: 1px solid #334155;\r\n}\r\n\r\n.tabs-header-wrapper::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  width: 40px;\r\n  background: linear-gradient(to right, transparent, #0f172a);\r\n  pointer-events: none;\r\n}\r\n\r\n.tabs-header {\r\n  display: flex;\r\n  gap: 4px;\r\n  padding: 12px 16px;\r\n  overflow-x: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n  scrollbar-width: none;\r\n}\r\n\r\n.tabs-header::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.tab-button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 16px;\r\n  background-color: transparent;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px 6px 0 0;\r\n  color: #94a3b8;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.tab-button:hover {\r\n  color: #cbd5e1;\r\n  border-color: #475569;\r\n}\r\n\r\n.tab-button.active {\r\n  background-color: #1e293b;\r\n  border-color: #475569;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.tabs-content {\r\n  flex: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.no-selection {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  color: #64748b;\r\n  font-size: 16px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
